import request from '@/axios/config'
import { API_ENDPOINTS } from '@/pages/MyNetwork/MyReferralNetwork/types'

export const recordInviteVisit = (organizationId: string) => {
  request.post(API_ENDPOINTS.RECORD_VISIT, { organizationId }).catch(err => {
    // eslint-disable-next-line no-console
    console.error('Failed to record invite visit:', err)
  })
}
